import { 
    hasValue 
} from "../../../../../general/js/general-helpers";
import { getMainAddress } from "../../../components/forms/helpers/form-helpers/upgrade-form-helper";
import { formConstants } from "../../../components/utils/constants/form-constants";

export function getUserDetailsForSaveToAddressBookRequest(userDetails) {
    if (!hasValue(userDetails)){
        return [];
    }

    let userAttributes = {
        FirstName: userDetails[formConstants.firstName],
        LastName: userDetails[formConstants.lastName]
    }
    
    const mainAddress = getMainAddress(userDetails);

    if (hasValue(mainAddress) && hasValue(mainAddress[formConstants.country])) {
        userAttributes.Country = mainAddress[formConstants.country];
    }

    return getFormattedDotdigitalUserAttributeList(userAttributes);
}

export function getSaveUserToAddressBookRequestModel(userDetails = [], userEmail = '', addressBookData = {}){
    if(!hasValue(userDetails) || !hasValue(userEmail) || !hasValue(addressBookData) || addressBookData.addressBookID === 0){
        return undefined;
    }
    
    return {
        UserDetails: userDetails,
        Email: userEmail,
        AddressBookID: addressBookData.addressBookID
    };
}

function getFormattedDotdigitalUserAttributeList(attributes = {}) {
    let dotDigitalAttributes = [];
    
    if(!hasValue(attributes)){
        return dotDigitalAttributes;
    }

    Object.keys(attributes).forEach(key => {
        const attribute = getFormattedDotdigitalUserAttribute(key, attributes[key]);
        
        if (hasValue(attribute)){
            dotDigitalAttributes.push(attribute);
        }
    });

    return dotDigitalAttributes;
}

function getFormattedDotdigitalUserAttribute(key = '', value = null) {
    if (!hasValue(key) || !hasValue(value)){
        return {};
    }

    return {
        Key: key,
        Value: value
    }
}